import  booleanPointOnLine  from '@turf/boolean-point-on-line';
import  nearestPointOnLine  from '@turf/nearest-point-on-line';
import GeoJSON from "ol/format/GeoJSON.js";
import  toTurf  from './toTurf.js';
import  fromTurf  from './fromTurf.js';

export default function getNearestPointOnLine(point, line, mapProjection) {
    var formatgeo = new GeoJSON();
    var lastinturf = toTurf(point, mapProjection, formatgeo);
    var nowinturf = toTurf(line, mapProjection, formatgeo);
    if (!booleanPointOnLine(lastinturf, nowinturf)) {
        var nearpoint = nearestPointOnLine(nowinturf, lastinturf);
        var interinol = fromTurf(nearpoint, mapProjection, formatgeo);
        return interinol;
    } else {
        return point;
    }
}
